import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';

@Injectable()
export class NotificationService {

  constructor(private base: BaseService) { }

  send(data){
  	return this.base.post('/api/sent-notification', data);
  }
}
